// Retrieve image src from element
const extractUrl = (str: string): string | null => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(str, 'text/html')
  const elem = doc.querySelector('iframe,img') as HTMLImageElement
  if (elem) {
    return elem.src
  } else {
    return null
  }
}

export { extractUrl }
